/* eslint-disable react/display-name */
import React from "react";

// favorite icon svg path string so we can animate the fill
const FAVORITE_PATH =
  "M17.75 5.50676C17.75 2.87967 15.6569 0.75 13.075 0.75C11.6146 0.796301 10.2348 1.4421 9.25 2.54027C8.26516 1.4421 6.88538 0.796301 5.425 0.75C2.84307 0.75 0.75 2.87967 0.75 5.50676C0.75 8.89703 4.7875 12.6419 6.7 14.5878L8.638 16.5597C8.75744 16.6814 8.91948 16.7498 9.0885 16.75H9.4115C9.58052 16.7498 9.74256 16.6814 9.862 16.5597L11.8 14.5878C13.7125 12.6419 17.75 8.89703 17.75 5.50676Z";

/**
 * Map of icon types that need custom JS-driven rendering. Currently just
 * `favorite`, which animates fill-opacity on the `selected` state. All other
 * v2 icons render from their .svg files in `assets/v2-icons/` via Icon's
 * default ReactSVG path.
 */
export const ICON_RENDERERS = {
  // eslint-disable-next-line react/display-name
  favorite: ({ selected }) => (
    <svg
      viewBox="-1.0278 -2.5278 20.5556 20.5556"
      width="100%"
      height="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={FAVORITE_PATH}
        fill="currentColor"
        fillOpacity={selected ? 1 : 0}
        stroke="currentColor"
        strokeLinejoin="round"
        style={{ transition: "fill-opacity 200ms ease" }}
      />
    </svg>
  )
};
